<div class="reports-content container">
    <cmps-wait-status *ngIf="params.pendingData"></cmps-wait-status>
    <div
        class="insight-backdrop-overlay"
        (click)="popUpService.hide()"
        *ngIf="popUpVisible"
    ></div>
    <div class="row">
        <div
            *ngIf="params.notFound"
            class="col-12"
        >
            <h6 class="alert alert-warning text-center">
                No data was found for this parameters
            </h6>
        </div>
        <div
            *ngIf="params.invalidDate"
            class="col-12"
        >
            <h6 class="alert alert-warning text-center">
                Please check the entered date.
            </h6>
        </div>
        <div class="mt-3 col-6">
            <label>Name:&nbsp;</label>
            <span class="f-s-75-2">{{ params.selectedUser?.name }}</span>
            <button
                (click)="onSelectUser($event)"
                class="green btn-mini"
            >
                <cmps-icon svgIcon="pencil"></cmps-icon>
            </button>
        </div>

        <div class="mt-3 col-6">
            <label
                class="mr-3 mb-0"
                id="reportDate2"
            >
                Date
            </label>
            <div class="input-group">
                <input
                    #dp="ngbDatepicker"
                    [(ngModel)]="params.selDate"
                    (ngModelChange)="selectedDate()"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    class="form-control"
                    aria-labelledby="reportDate"
                    ngbDatepicker
                />
                <div class="input-group-append">
                    <button
                        type="button"
                        class="btn btn-secondary cmps-cdk-py-0dot5"
                        aria-label="Toggle date picker"
                        [attr.aria-expanded]="dp.isOpen()"
                        (click)="dp.toggle()"
                    >
                        <cmps-icon
                            class="green"
                            svgIcon="calendar"
                        ></cmps-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="mt-3 col-12">
            <label
                class="mr-3 mb-0"
                id="reportDate1"
            >
                Select Role
            </label>
            <ng-select
                [(ngModel)]="params.selRole"
                [options]="roleList"
                placeholder="Select a Role"
                (selected)="selectedRole($event)"
            ></ng-select>
        </div>
    </div>

    <div class="row">
        <div class="mt-3 col-6">
            <label
                class="mr-3 mb-0"
                id="reportDate3"
            >
                Outcome
            </label>
            <ng-select
                [(ngModel)]="params.selOutcome"
                [options]="metricsOutcomes"
                placeholder="List of Outcome Metrics"
                (selected)="selectedOutcome($event)"
            ></ng-select>
        </div>

        <div
            class="mt-3 col-6"
            *ngIf="params.selOutcome && params.selBehaviour && pendingOutcome"
        >
            <cmps-wait-status></cmps-wait-status>
        </div>

        <div
            class="mt-3 col-6"
            *ngIf="params.selOutcome && params.selBehaviour && !pendingOutcome"
        >
            <label
                class="mr-3 mb-0"
                id="reportDate4"
            >
                Target for Outcome
            </label>
            <input
                type="text"
                class="form-control"
                [disabled]="!params.selOutcome && !params.selBehaviour"
                value="{{ params.inputOutcomeTarget }}"
                #outcomeTarget
                (input)="enterOutcomeTarget(outcomeTarget.value)"
                (keypress)="numberOnly($event)"
                placeholder="0.00"
            />
        </div>
    </div>
    <div class="row">
        <div
            class="mt-3 col-6"
            *ngIf="params.selOutcome"
        >
            <label
                class="mr-3 mb-0"
                id="reportDate5"
            >
                Behaviour
            </label>
            <ng-select
                [disabled]="!params.selOutcome"
                [(ngModel)]="params.selBehaviour"
                [options]="metricsBehaviours"
                placeholder="List of Behaviour Metrics"
                [ngClass]="outcomeModified ? 'cmpsEnabled' : 'cmpsDisabled'"
                (selected)="selectedBehaviour($event)"
            ></ng-select>
        </div>

        <div
            class="mt-3 col-6"
            *ngIf="params.selOutcome && params.selBehaviour && pendingBehaviour"
        >
            <cmps-wait-status></cmps-wait-status>
        </div>

        <div
            class="mt-3 col-6"
            *ngIf="
                params.selOutcome && params.selBehaviour && !pendingBehaviour
            "
        >
            <label
                class="mr-3 mb-0"
                id="reportDate6"
            >
                Target for Behaviour
            </label>
            <input
                type="text"
                class="form-control"
                #behaviourTarget
                [disabled]="!params.selOutcome && !params.selBehaviour"
                value="{{ params.inputBehaviorTarget }}"
                (input)="enterBehaviourTarget(behaviourTarget.value)"
                (keypress)="numberOnly($event)"
                placeholder="0.00"
            />
        </div>

        <div class="mt-3 col-12">
            <cmps-wait-status *ngIf="!params.plotGenerated"></cmps-wait-status>
            <button
                *ngIf="params.plotGenerated"
                [disabled]="!isDone"
                type="button"
                class="btn btn-primary pull-right"
                (click)="onGenerateReport()"
            >
                Generate Report
            </button>
        </div>
    </div>
</div>
